import type { OfferLocaleOverrides } from '../base';

export const KYOverrides: OfferLocaleOverrides = {
  locale: 'KY',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            layout.concat([
              [
                {
                  name: 'property.taxIdNumber',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
          },
        },
      },
    },
  },
};
